import { render, staticRenderFns } from "./pass.vue?vue&type=template&id=c72c6994&scoped=true&"
import script from "./pass.vue?vue&type=script&lang=js&"
export * from "./pass.vue?vue&type=script&lang=js&"
import style0 from "./pass.vue?vue&type=style&index=0&id=c72c6994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72c6994",
  null
  
)

export default component.exports